import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import LabelType from '@/Controls/Label';

export default class CheckBoxThreeState extends Control {

    protected Label = ComponentManager.getControl<typeof LabelType>('Label');
    protected jQueryControl: JQuery;
    protected label: LabelType;

    public constructor(protected viewModel, protected element?: JQuery) {
        super(viewModel, element);        

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><input type="checkbox"><div class="element"></div></div>');

        this.widget(null);

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'checkbox',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            }),
            attr: {
                'data-value': this.viewModel.value,
                'data-checked': this.viewModel.isChecked
            },
            hotkey: {
                shortcut: 'space',
                handler: (e: ExtendedKeyboardEvent) => {
                    this.viewModel.toggleIfEnabled();
                    e.stopPropagation();
                    e.preventDefault();
                },
                isGlobal: false
            }
        });

        this.applyBindings(this.jQueryControl.find('input'), {
            checked: this.viewModel.isChecked,
            enable: this.viewModel.isEnabled,
            attr: {
                id: this.identifier
            }
        });

        this.applyBindings(this.jQueryControl.find('.element'), {
            locator: this.viewModel.locator,
            focus: this.viewModel.isFocusable,
            html: this.defineComputed(() => {
                switch (this.viewModel.isChecked()) {
                    // Gibt Inhalt der Checkbox zurück
                    case true:
                        return '&#10003;'; // Checkmark
                    case false:
                        return '';
                    default:
                        return '&#9724;'; // Schwarzes Quadrat
                }
            })
        });

        this.addEventHandler('click', this.jQueryControl, () => {
            this.viewModel.toggleIfEnabled();
        }, '.element');

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label, $('<label for=" ' + this.identifier + '">').appendTo(this.jQueryControl));
            const tuple = this.label.getTuple();
            this.addEventHandler('click', tuple.control, () => {
                this.viewModel.toggleIfEnabled();
            });
        }

        if (this.viewModel.onClick != null) {
            this.addEventHandler('click', this.jQueryControl, (event: JQuery.Event) => {
                if (this.viewModel.isEnabled()) {
                    this.viewModel.onClick(this.viewModel.isChecked());
                }
            }, 'label, .element');
        }
    }

    public addLabelReference(label: JQuery): JQuery {
        let id = this.identifier + '-input';
        this.getControl().find('input').attr('id', id);
        label.attr('for', id);
        return label;
    };
}

ComponentManager.setControl('CheckBoxThreeState', CheckBoxThreeState, 'RADPresentation.HTMLClient.DefaultViewExtensions');